const { format } = require('./formatter');

module.exports = {
  format
}